import { snakeCase } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import withFilter from "../enhancers/withFilter";

class PillSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e, item) {
    e.preventDefault();
    this.props.handleFilterChange(item.value);
  }

  renderButton = (item, key, isActive, disabled, inner = false) => (
    <Button
      key={key}
      disabled={disabled}
      variant={isActive ? "info" : "link"}
      className={`pill-switch__item${inner ? "-inner" : ""} ${
        isActive ? "pill-switch__item--active" : ""
      }`}
      onClick={e => this.handleChange(e, item)}
      data-testid={`pill_switch_${snakeCase(item?.label?.toLowerCase())}`}
    >
      {item.label}
    </Button>
  );

  render() {
    const { items, activeFilter, disabled, id } = this.props;
    return (
      <ButtonGroup
        id={id}
        className={`pill-switch`}
        style={{ maxWidth: "550px" }}
      >
        {items.map((item, idx) => {
          if (item.fields) {
            return (
              <div key={item.label} className="pill-switch__inner-container">
                {item.label}&nbsp;&nbsp;&nbsp;-
                <ButtonGroup className="pill-switch__inner-group" key={idx}>
                  {item.fields.map(subItem => {
                    const isActive = activeFilter === subItem.value;
                    return this.renderButton(
                      subItem,
                      subItem.value,
                      isActive,
                      disabled,
                      true
                    );
                  })}
                </ButtonGroup>
              </div>
            );
          }

          const isActive = activeFilter === item.value;

          return this.renderButton(item, item.value, isActive, disabled);
        })}
      </ButtonGroup>
    );
  }
}

PillSwitch.propTypes = {
  id: PropTypes.string,
  activeFilter: PropTypes.any,
  handleFilterChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  items: PropTypes.array
};

PillSwitch.defaultProps = {
  disabled: false,
  items: []
};

export default withFilter(PillSwitch);
